import { type OptionItem } from "@client/types";

export const expandUnits = (units: Array<OptionItem | string>): OptionItem[] =>
  units.map((x) => (typeof x === "string" ? { label: x, value: x } : x));

export const parseValueInner = (value: string | number | null | undefined): RangeValue => {
  if (value || value === 0) {
    const match = value.toString().match(/^(-?[\d.]+)(.+)?/);
    if (match) {
      return {
        number: +match[1],
        unit: match[2]
      };
    }
  }

  return {
    number: 0
  };
};

export interface RangeValue {
  number: number;
  unit?: string;
}
export const parseValue = (
  value: string | number | null | undefined,
  units: Array<OptionItem | string> | undefined,
  defaultUnit: string | undefined
): RangeValue => {
  const parsed = parseValueInner(value);
  if (parsed.unit) {
    const expandedUnits = expandUnits(units ?? []);
    if (!expandedUnits.some((x) => x.value === parsed.unit)) {
      parsed.unit = undefined;
    }
  } else {
    parsed.unit = defaultUnit ?? (units?.length ? expandUnits(units)[0].value : undefined);
  }
  return parsed;
};

export const serializeValue = (value: RangeValue): string =>
  value.unit === "auto" ? value.unit : `${value.number}${value.unit || ""}`;
